export default __webpack_public_path__ + "static/media/cr1.47e28c59.png";